import { LazyPage, OutcomePage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The gates live on the layout route above this one.
function OutcomeRoute() {
  return (
    <LazyPage>
      <OutcomePage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/outcome-optimization/$outcomeId')({
  component: OutcomeRoute,
});
